import { render, staticRenderFns } from "./cabinetInfo.vue?vue&type=template&id=5b6f1065&scoped=true&"
import script from "./cabinetInfo.vue?vue&type=script&lang=js&"
export * from "./cabinetInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f1065",
  null
  
)

export default component.exports